<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Source and verify reliable suppliers across Africa</h2>
    <p>Minimise the risk and confirm the credibility and performance of your suppliers with Asoko’s  on-demand research and company verification across the continent. We deliver
      reliable and authentic insight into private corporates in Africa’s most dynamic economies and the people who run them, including their executives, directors and shareholders.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mncs-procurement-team-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'MNCs Procurement Team Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'MNCs Procurement Team Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
